import { useLocation } from "react-router";

export const useSearchParams = (key: string) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search as string);

  return searchParams.get(key) as string;
};
